export enum Navigation {
  Conditions = "conditions",
  Escalation = "escalation",
  MechanicalAndElectrical = "MechanicalAndElectrical",
  Modifications = "modifications",
  Qualifications = "qualifications",
  ServiceHistory = "serviceHistory",
  Submitted = "submitted",
  Summary = "summary",
}
